import { useState } from "react";
import { Stethoscope, Syringe, HeartPulse, Building2, Hospital } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { CityData } from "@/utils/cityData";
interface PracticeTypeSelectorProps {
  city: CityData;
}
const PracticeTypeSelector = ({
  city
}: PracticeTypeSelectorProps) => {
  const [selectedType, setSelectedType] = useState<string>("hausarzt");
  const practiceTypes = [{
    id: "hausarzt",
    icon: Stethoscope,
    title: "Hausarztpraxen",
    count: "2.800+",
    coverage: "ab 250.000 €",
    premium: "49€/Monat",
    risks: ["Patientendaten-Verlust", "Praxisverwaltungssoftware-Ausfall", "DSGVO-Verstöße"]
  }, {
    id: "zahnarzt",
    icon: Syringe,
    title: "Zahnarztpraxen",
    count: "1.500+",
    coverage: "ab 300.000 €",
    premium: "59€/Monat",
    risks: ["Röntgendaten-Verschlüsselung", "Abrechnungssystem-Hack", "Terminbuch-Ausfall"]
  }, {
    id: "facharzt",
    title: "Facharztpraxen",
    icon: HeartPulse,
    count: "2.200+",
    coverage: "ab 350.000 €",
    premium: "69€/Monat",
    risks: ["Spezialsoftware-Ausfall", "Forschungsdaten-Diebstahl", "Telemedizin-Angriff"]
  }, {
    id: "mvz",
    title: "MVZ & Gemeinschaftspraxen",
    icon: Building2,
    count: "450+",
    coverage: "ab 500.000 €",
    premium: "129€/Monat",
    risks: ["Netzwerk-Kompromittierung", "Multi-Standort-Angriff", "Zentrale Datenverlust"]
  }, {
    id: "klinik",
    title: "Kliniken",
    icon: Hospital,
    count: "120+",
    coverage: "ab 1.000.000 €",
    premium: "299€/Monat",
    risks: ["OP-System-Ausfall", "Notaufnahme-IT-Crash", "Massenhafte Datenlecks"]
  }];
  const selected = practiceTypes.find(t => t.id === selectedType) || practiceTypes[0];
  const SelectedIcon = selected.icon;
  return <section className="py-8 sm:py-12 lg:py-16 relative">
      
    </section>;
};
export default PracticeTypeSelector;